import { render } from "./EventList.vue?vue&type=template&id=3db42246&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=3db42246&scoped=true&lang=css"

import exportComponent from "D:\\JotaDev\\Vue\\VueMastery\\Real-World_Vue-3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db42246"]])

export default __exports__